import { render, staticRenderFns } from "./input_auth.vue?vue&type=template&id=1caa86aa&lang=pug&"
import script from "./input_auth.vue?vue&type=script&lang=js&"
export * from "./input_auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1caa86aa')) {
      api.createRecord('1caa86aa', component.options)
    } else {
      api.reload('1caa86aa', component.options)
    }
    module.hot.accept("./input_auth.vue?vue&type=template&id=1caa86aa&lang=pug&", function () {
      api.rerender('1caa86aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/mail/input_auth.vue"
export default component.exports